import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Table, message, Tag, Pagination, Alert } from 'antd';
import ColegiadoService from '../../../services/api/colegiados';
import CorreoService from '../../../services/api/correos';
import helper from '../../../utils/helper';
import { EyeOutlined, SendOutlined } from '@ant-design/icons';

class IndexPagoPendientes extends Component {
  state = {
    cargando: false,
    colegiados: [],
    page: {
      number: 1,
      per_page: 15,
      order_column: 'created_at',
      order_type: 'desc',
      from: 0,
      to: 0,
      last_page: 0,
      total: 0,
      buscar_texto: '',
    },
  };

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(this.handleChangeLocation);

    if (this.props.location && this.props.location.search) {
      const queryString = new URLSearchParams(this.props.location.search);
      if (queryString) {
        const buscar_texto = queryString.get('buscar_texto');
        const configPage = Object.assign({}, this.state.page);
        configPage.buscar_texto = buscar_texto;
        this.setState({
          page: configPage,
        });
      }
    }

    this.cargarPagosPendientes();
  }

  handleChangeSearch = (value) => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = value.target.value;
    configPage.number = 0;
    this.setState({
      page: configPage,
      buscar_texto: value.target.value
    }, () => {
      this.cargarPagosPendientes();
    });
  }

  handleChangeSearchIcon = () => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = this.state.buscar_texto;
    this.setState({
      page: configPage,
      buscar_texto: this.state.buscar_texto
    }, () => {
      this.cargarPagosPendientes();
    });
  }

  cargarPagosPendientes = (path = undefined) => {
    this.setState({
      cargando: true,
    });

    if (!path || path === undefined) {
      path = `?page=${this.state.page.number}&per_page=${this.state.page.per_page}&order_column=${this.state.page.order_column}&order_type=${this.state.page.order_type}&pago_pendiente=true`;
      if (this.state.page && this.state.page.buscar_texto && this.state.page.buscar_texto !== '') {
        path = `${path}&buscar_texto=${this.state.page.buscar_texto}`;
      }
    }

    ColegiadoService.getColegiados(
      path,
      (page) => {
        if (page && page.data && page.data.length > 0) {
          const configPage = Object.assign({}, this.state.page);
          configPage.from = page.from;
          configPage.to = page.to;
          configPage.last_page = page.last_page;
          configPage.total = page.total;
          configPage.number = page.current_page;
          configPage.per_page = parseInt(page.per_page);
          configPage.buscar_texto = page.buscar_texto ? page.buscar_texto : '';

          this.setState({
            cargando: false,
            colegiados: page.data,
            page: configPage,
          });
        } else {
          this.setState({
            colegiados: [],
            cargando: false,
          });
        }
      },
      (error, result) => {
        if (error) {
          message.error(error.message);
          this.setState({
            cargando: false,
          });
        }
      }
    );
  };

  handleChangeLocation = (location, action) => {
    const queryString = new URLSearchParams(location.search);
    const buscar_texto = queryString.get('buscar_texto');

    if (buscar_texto && buscar_texto != null) {
      const page = Object.assign({}, this.state.page);

      page.buscar_texto = buscar_texto;

      this.setState({
        page,
      });

      setTimeout(() => {
        this.cargarPagosPendientes();
      }, 10);
    }
  };

  handleChangePerPage = (current, pageSize) => {
    const page = Object.assign({}, this.state.page);
    page.number = current;
    page.per_page = pageSize;
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&pago_pendiente=true`;
    if (page.buscar_texto !== undefined || page.buscar_texto !== '') {
      path = `${path}&buscar_texto=${page.buscar_texto}`;
    }
    this.props.history.push(path);
    this.cargarPagosPendientes(path);
  };

  showTotal = (total) => {
    return `Total ${total} registros`;
  };


  handleEnviarCorreoDeuda = (record) => {
    this.setState({enviando_coreo: true});
    CorreoService.enviarCorreoDeuda({
      id: record?.id
    },  (response) => {
      if (response) {
        message.success('✅ ¡Proceso completado con éxito!');
        this.setState({enviando_coreo: false, enviando_coreo_message: true});
      }
    }, (error) => {
      if (error) {
        message.error(error.message);
        this.setState({enviando_coreo: false});
      }
    });
  }

  render() {
    const columns = [
      {
        title: 'N°',
        dataIndex: 'name',
        key: 'name',
        responsive: ['lg'],
        width: 50,
        render: (text, record, index) => {
          return <div>{index + 1}</div>;
        },
      },
      {
        title: 'RUC/DNI',
        dataIndex: 'numero_documento',
        key: 'numero_documento',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        width: 120,
        render: (text, record, index) => {
          return <div title={ record.monto_bono === 0 && record.es_bono_usado_anual === 1 ? 'El bono para capacitación se usó al 100%.': '' }>{ text }</div>;
        },
      },
      {
        title: 'Nombre del colegiado',
        dataIndex: 'nombres',
        key: 'nombres',
        ellipsis: true,
        responsive: ['lg', 'xl'],
      },
      {
        title: 'Código Afiliado',
        dataIndex: 'codigo_afiliado',
        responsive: ['lg', 'xl'],
        ellipsis: true,
      },      
      {
        title: 'Fecha Colegiatura',
        dataIndex: 'fecha_colegiatura_1_temp',
        key: 'fecha_colegiatura_1_temp',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        ellipsis: true,
      },
      {
        title: 'Estado',
        dataIndex: 'estado_afiliado_formato',
        key: 'estado_afiliado_formato',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        width: 220,
        render: (text) => (
          <Tag
            color={text === 'INHABILITADO POR DEUDA' ? 'blue' : text === 'VITALICIO' ? 'red' : text === 'HABIL' ? 'green' : ''}
          >
            {text}
          </Tag>
        ),
      },
      {
        title: 'Detalle',
        dataIndex: 'estado',
        key: 'estado',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        width: 80,
        render: (text, record) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {helper.tienePermiso(this.props.permisos, 'Ver detalle pago pendiente') ? (
                <Link to={`/pago-pendiente/${record.id}/show`}>
                  <EyeOutlined style={{ color: '#1890ff' }} />
                </Link>
              ) : (
                <EyeOutlined style={{ color: '#b5b5b5' }} />
              )}
            </div>
          );
        },
      },
      {
        title: 'Correo',
        dataIndex: 'id',
        key: 'id',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        width: 80,
        render: (text, record) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <SendOutlined style={{ color: '#1890ff' }} onClick={ () => this.handleEnviarCorreoDeuda(record) } />
            </div>
          );
        },
      },
    ];

    return (
      <div>
        {
          this.state.enviando_coreo_message &&
          <Alert
          style={{ marginBottom: 16 }}
            type='success'
            message={<div>
              🎉 ¡Todo listo! <br/>
              El correo fue enviado con éxito. ¡Gracias por tu paciencia y confianza!
            </div>}/>
        }
        <div className="page-header">
          <h2>Pagos Pendientes</h2>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
            <div className="topnav__search">
              <input
                type="text"
                placeholder="Buscar..."
                onChange={this.handleChangeSearch}
                value={ this.state.buscar_texto }
              />
              <i onClick={() => this.handleChangeSearchIcon()} className="bx bx-search" style={{cursor: 'pointer'}}></i>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              {!helper.tienePermiso(this.props.permisos, 'Ver registro pagos pendientes') ? (
                <Alert
                  message="Permiso"
                  description="No tiene permiso para ver lista de pagos pendientes"
                  type="error"
                />):
                <div className="card__body">
                  <Table
                    rowKey={(record) => record.id}
                    columns={columns}
                    dataSource={this.state.colegiados}
                    pagination={false}
                    loading={this.state.cargando}
                    size="small"
                  />
                  <div style={{ paddingTop: 12, textAlign: 'right' }}>
                    <Pagination
                      size="small"
                      showTotal={this.showTotal}
                      total={this.state.page.total}
                      current={this.state.page.number}
                      pageSize={this.state.page.per_page}
                      onChange={this.handleChangePerPage}
                      onShowSizeChange={this.handleChangePerPage}
                      pageSizeOptions={[10, 20, 30, 40]}
                      showQuickJumper
                      showSizeChanger
                    />
                  </div>
                </div>
              }              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permisos: state && state.user && state.user.permisos.length > 0 ? state.user.permisos : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexPagoPendientes);
